var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToolAdmin',{attrs:{"user":_vm.user,"tool-id":"CustomerServiceArtificialAgent","tool-name":"Artificial Agent","tool-icon":"mdi-android"}})
}
var staticRenderFns = []

export { render, staticRenderFns }